"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MbTimeOut = void 0;
// Events
const events_1 = require("../../security/events");
// Types
const types_1 = require("../../security/timeOut/types");
// Helpers
const timeOut_helper_1 = require("../../security/timeOut/helpers/timeOut.helper");
const timeOut_1 = require("../../security/events/timeOut");
class MbTimeOut {
    constructor(session, authenticator) {
        this.initialTimer = -1;
        this.warningInterval = -1;
        this.timeFrame = timeOut_helper_1.INITIAL_TIME_FRAME;
        this.initTimeOutData = (data) => {
            this.clearTimer();
            if (data?.expiresIn && data?.timeOutStamp) {
                this.data = { ...types_1.INITIAL_STATE, countDown: (0, timeOut_helper_1.getCountdown)(data.timeOutStamp) };
                this.timeOutStamp = data.timeOutStamp;
                (0, timeOut_1.publishUpdatedDataTimeOutEvent)(this.data);
            }
            else {
                this.data = { ...types_1.INITIAL_STATE };
                this.timeOutStamp = null;
            }
        };
        this.data = types_1.INITIAL_STATE;
        this.session = session;
        this.authenticator = authenticator;
        this.timeOutStamp = session.getData()?.timeOutStamp ?? null;
        this.initTimeOutData(this.session.getData());
        (0, events_1.subscribeUpdatedDataSessionEvent)((data) => {
            data && this.initTimeOutData(data);
        });
    }
    setUpdate(callback) {
        (0, timeOut_1.subscribeUpdatedDataTimeOutEvent)(callback);
    }
    checkTimeOut() {
        (0, events_1.subscribeErrorRefreshingSessionEvent)(() => {
            this.expireTimeout();
        });
        this.clearTimer();
        this.data.countDown = (0, timeOut_helper_1.getCountdown)(this.timeOutStamp);
        if (this.data.countDown > types_1.TimeOutCountDown.AT_ZERO) {
            this.createTimer();
        }
        else {
            this.expireTimeout();
        }
    }
    createTimer() {
        this.data.countDown = (0, timeOut_helper_1.getCountdown)(this.timeOutStamp);
        if (this.data.countDown > types_1.TimeOutCountDown.LAST_MINUTE) {
            this.startInitialTimer();
        }
        else {
            this.startWarningInterval();
        }
    }
    startInitialTimer() {
        this.timeFrame = (0, timeOut_helper_1.getDynamicTimeFrame)(this.timeOutStamp);
        this.initialTimer = setTimeout(() => {
            this.checkTimeOut();
        }, this.timeFrame); // recursive timeout
    }
    startWarningInterval() {
        this.warningInterval = setInterval(() => {
            if (this.data.countDown <= types_1.TimeOutCountDown.AT_ZERO) {
                this.expireTimeout();
            }
            else {
                this.data = { isExpired: false, isWarning: true, countDown: (0, timeOut_helper_1.getCountdown)(this.timeOutStamp) };
                (0, timeOut_1.publishUpdatedDataTimeOutEvent)(this.data);
            }
        }, timeOut_helper_1.FINAL_TIME_FRAME);
    }
    clearTimer() {
        if (this.initialTimer) {
            clearTimeout(this.initialTimer);
        }
        clearInterval(this.warningInterval);
    }
    expireTimeout() {
        this.data = { ...this.data, isExpired: true, isWarning: false };
        this.doFinnish();
        this.clearTimer();
        (0, timeOut_1.publishUpdatedDataTimeOutEvent)(this.data);
    }
    async doRefresh() {
        try {
            await this.session.refresh();
            this.initTimeOutData(this.session.getData());
            this.checkTimeOut();
        }
        catch (error) {
            console.error('Error refreshing');
        }
    }
    async doFinnish() {
        if (this.session?.getData()?.accessToken) {
            try {
                await this.authenticator.logout();
            }
            catch (error) {
                console.error('Error logout');
            }
        }
    }
}
exports.MbTimeOut = MbTimeOut;
//# sourceMappingURL=timeout.js.map